<template>
  <div width="60" class="align-center text-center mr-4">
    <v-img :src="getSrc(id)" max-width="60" :alt="caption"></v-img>
    <p class="text-body-1 font-weight-medium">
      {{ caption }}
    </p>
  </div>
</template>

<script>
const TECH_IMAGE_BY_ID = {
  angular: require("@/assets/tech_logo/angular.png"),
  aws: require("@/assets/tech_logo/aws.png"),
  azure: require("@/assets/tech_logo/azure.png"),
  c: require("@/assets/tech_logo/c.png"),
  csharp: require("@/assets/tech_logo/csharp.png"),
  claude: require("@/assets/tech_logo/claude.png"),
  docker: require("@/assets/tech_logo/docker.png"),
  gemini: require("@/assets/tech_logo/gemini.png"),
  go: require("@/assets/tech_logo/go.png"),
  java: require("@/assets/tech_logo/java.png"),
  js: require("@/assets/tech_logo/js.png"),
  kubernetes: require("@/assets/tech_logo/kubernetes.png"),
  php: require("@/assets/tech_logo/php.png"),
  python: require("@/assets/tech_logo/python.png"),
  pytorch: require("@/assets/tech_logo/pytorch.png"),
  react: require("@/assets/tech_logo/react.png"),
  rust: require("@/assets/tech_logo/rust.png"),
  sql: require("@/assets/tech_logo/sql.png"),
  swift: require("@/assets/tech_logo/swift.png"),
  tensorflow: require("@/assets/tech_logo/tensorflow.png"),
  terraform: require("@/assets/tech_logo/terraform.png"),
  ts: require("@/assets/tech_logo/ts.png"),
  //todo: linux, git, github, gitlab, bitbucket, jira, confluence, slack, notion, figma
};
const GENERIC_TECH_IMAGES = [
  require("@/assets/tech_logo/generic1.png"),
  require("@/assets/tech_logo/generic2.png"),
  require("@/assets/tech_logo/generic3.png"),
  require("@/assets/tech_logo/generic4.png"),
];

export default {
  name: "TechnologyIcon",
  props: {
    id: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      required: true,
    },
  },
  methods: {
    getSrc(id) {
      return (
        TECH_IMAGE_BY_ID[id] ||
        GENERIC_TECH_IMAGES[
          Math.floor(Math.random() * GENERIC_TECH_IMAGES.length)
        ]
      );
    },
  },
};
</script>
